const SETTINGS = {
  INVALID_STRIPE_FEE:
    'Fee percentage cannot be less than 0 or greater than 100.',
  CANNOT_NEGATIVE: 'Cannot be less than 1.',
  FEE_FOR_ORGANIZATION: (org: string | number): string =>
    `Application Fee from ${org}.`,
  UPDATED: 'Settings updated.',
  INVALID_PERKS_PER_PAGE: 'Perks per page should not be less than 1.',
  INVALID_CONNECTIONS_UPTO: 'Number of connections should not be less than 1.',
  NEW_SIGNUPS: {
    SUCCESS: 'New signups settings updated successfully.',
    INVALID_EMAIL:
      'Invalid email, no emplopyer/merchant/student-body user found with this email.',
  },
  MOBILE_APP_INFO: {
    SUCCESS: 'Mobile app info updated successfully.',
  },
} as const;

export default SETTINGS;
